import { getStorage } from "@/common/utils/storage.js"
export default {
  // 下拉框
  ALLSELECT: {
    // #region -----------------------------------------------   对象部分   --------------------------------------
    // #region 优先级
    COLORPRIORITY: {
      P0: {
        background: "rgb(204, 51, 51)",
        color: "#fff",
      },
      P1: {
        background: "none",
        color: "rgb(255, 105, 180)",
      },
      P2: {
        background: "none",
        color: "rgb(248, 172, 89)",
      },
      P3: {
        background: "none",
        color: "blue",
      },
      P4: {
        background: "none",
        color: "green",
      },
      P5: {
        background: "none",
        color: "aqua",
      },
    },
    TEXTPRIORITY: {},
    // #endregion 优先级

    // #region 方案状态 all-全部 未开始-p_notstart 设计中-p_indesign 已完成-p_finish 暂停中-p_stop
    COLORPSTATUS: {
      p_indesign: {
        color: 'rgb(248, 172, 89)'
      },
      p_finish: {
        color: '#67C23A'
      },
      p_stop: {
        color: '#F56C6C'
      },
      p_notstart: {
        color: '#F56C6C'
      },
    },
    COLORREVIEWSTATUS:{
      history_reviewed: {
        color: '#F56C6C'
      },
      not_reviewed: {
        color: '#F56C6C'
      },
      under_review: {
        color: 'rgb(248, 172, 89)'
      },
      reviewed: {
        color: '#67C23A'
      },
    },
    TEXTPSTATUS: {},
    // #endregion 方案状态

    // #region 需求状态  默认选中进行中和未开始，已完成不选  待方案-pi_waitplan  待排期-pi_waitschedule 进行中-pi_running 已上线-pi_finsh 暂停中-pi_stop
    COLORPISSUESTATUS: {
      pi_running: {
        color: 'rgb(248, 172, 89)'
      },
      pi_finsh: {
        color: '#67C23A'
      },
      pi_stop: {
        color: '#F56C6C'
      },
      pi_waitplan: {
        color: '#F56C6C'
      },
      pi_waitschedule: {
        color: '#F56C6C'
      }
    },
    TEXTPISSUESTATUS: {},
    // #endregion 需求状态

    // #region 开发团队 多选
    TEXTORGS: {},
    TEXTORGSCHART: {},
    // #endregion 开发团队

    // #region 人员
    TEXTUSERS: {},
    TEXTUSERSEN: {},
    TEXTALLUSERS: {},
    TEXTALLUSERSEN: {},
    // #endregion 人员

    // #region 系统 可多选，按照我们定义的发布维度的系统，默认为空
    TEXTMODULES: {},
    TEXTFILTERMODULES:{},
    // #endregion 系统

    // #region 任务状态 选项参见任务状态总览
    TEXTTASKSTATUS: {},
    TEXTTASKSTATUSCHART: {},
    // #endregion 任务状态

    // #region 任务状态对应 diolagVisible
    TEXTTASKSTATUSDIOLOGVISIBLE: {
      '待开发': 'toDevelop',
      '开发中': 'developing',
      '待测试': 'toTest',
      '测试环境测试中': 'testEnvTesting',
      '预发环境测试中': 'preEnvTesting',
      'UAT测试中': 'uatTesting',
      '待发布': 'toRelease',
      '待发布(已申请)':'toRelease',
      '发布中': 'releaseing',
      '生产环境测试中': 'proEnvTesting', // 缺
      '已上线': 'online'
    },
    // #endregion

    // #region 中文任务状态对应的颜色
    TEXTTASKSTATUSCOLOR: {
      '预发环境验证中': {
        color: '#67C23A'
      },
      '客户联调中': {
        color: 'rgb(248, 172, 89)'
      }
    },
    // #endregion

    // #region  测试结果状态 0 成功 1 失败
    TEXTTESTRESULT: {
      0: '成功',
      1: '失败',
    },
    // #endregion

    // #region 标签
    TEXTTAGS: {},
    // #endregion

    // #region 主域名
    TEXTDOMAINS: {},
    // #endregion

    // #region 进度条状态
    PROGRESSSTART: {
      customColor: "#1989fa",
      percentage: 0,
      title: "",
    },
    PROGRESSDOING: {
      customColor: "#1989fa",
      title: "",
      percentage: 30,
      completeInfo: "",
    },
    PROGRESSSUCCESS: {
      customColor: "",
      percentage: 100,
      status: "success",
      completeInfo: "发布成功",
      title: ""
    },
    PROGRESSFAIL: {
      customColor: "",
      percentage: 100,
      status: "exception",
      completeInfo: "发布失败",
      title: ""
    },
    // #endregion

    // #region 开发代码质量检测引擎
    CODESCANENGINE: {},
    // #endregion

    // #region 用例测试结果
    TEXTTESTSTATUS: {
      'success': '成功',
      'failed': '失败'
    }

    // #endregion
  },
  // 进度条
  PROGRESSSBAR: {
    customColor: '#1989fa',
    completeInfo: '',
    percentage: 0,
    title: '',
    status: '' // 失败 exception 成功 success
  },
  // 用户权限
  USER: {
    authority: false
  },
  // 即时通讯
  WEBSOCKET: {
    url: '',
    params: {},
    msg: '',
    percent: 0,
    title: '',
    apiCount: 1
  },
  //以下是新增的 2023-11-22
  //会议类型
   MEETINGTYPE: {
    1: '会议',
    2: '邮件',
    3: '线下沟通',
  },
  //会议阶段类型
  STAGETYPE: {
    1: '需求讨论',
    2: '需求评审',
    3: '技术评审',
  },
  //bug 类型
  BUGTYPE: {
    1: 'Test',
    2: 'Staging',
    3: 'UAT',
    4: 'Production',
  },
  //技术评审状态
  NEWREVIEWSTATUS: {
    0: '未评审',
    1: '评审中',
    2: '已评审',
  },
//其他任务类型
  NEWOTHERTYPE: {
    1: '调研',
    2: '文档',
    3: '运维',
    4: '客户联调',
    5: '查代码'
  },
  //发布任务状态
  RELEASESTATUS: {
    0: '待发布',
    1: '生产环境测试中',
    2: '已上线',
    3: '取消',
  },
  //职能组织
  NEWTEXTORGSCHART: {
    '数字技术管理部': '数字技术管理部',
    '销售管理部': '销售管理部',
    '商城运营部': '商城运营部',
    '交付服务部': '交付服务部',
    //'狮行物流部': '狮行物流部',
    '人财管理部':'人财管理部',
    '供应链部':'供应链部',
    '全部': '全部',
  },
  token:getStorage('token', 'localStorage') || null,
  userInfo: getStorage('userInfo', 'localStorage')? JSON.parse(getStorage('userInfo', 'localStorage')): {}, //用户个人信息
  menuList: getStorage('menuList', 'localStorage')? JSON.parse(getStorage('menuList', 'localStorage')) : {}, //菜单栏菜单数据
  NEWALLSTATUSLIST: getStorage('ALLSTATUSLIST', 'localStorage')? JSON.parse(getStorage('ALLSTATUSLIST', 'localStorage')) : {}, //菜单栏菜单数据
  NEWALLSYSTEM: getStorage('ALLSYSTEM', 'localStorage')? JSON.parse(getStorage('ALLSYSTEM', 'localStorage')) : {}, //菜单栏菜单数据
  NEWALLUSERLIST: getStorage('ALLUSERLIST', 'localStorage')? JSON.parse(getStorage('ALLUSERLIST', 'localStorage')) : {}, //菜单栏菜单数据
  NEWALLMENULIST: getStorage('ALLMENULIST', 'localStorage')? JSON.parse(getStorage('ALLMENULIST', 'localStorage')) : {}, //菜单栏菜单数据
  NEWGITLABPATAM: getStorage('GITLABPATAM', 'localStorage')? JSON.parse(getStorage('GITLABPATAM', 'localStorage')) : {}, //菜单栏菜单数据
};
